// extracted by mini-css-extract-plugin
module.exports = {"searchButton":"MastheadSearchButton__searchButton___2yjtT","tpb":"MastheadSearchButton__tpb___27lxO","useTPBBimUpdates":"MastheadSearchButton__useTPBBimUpdates___2xJFt"};